// components/UI/PrescriptionUpload.js
import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import CloudUpload from "../../images/upload.jpg";
import "./index.css";

const PrescriptionUpload = ({ onUpload }) => {
  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        onUpload(acceptedFiles[0]);
      }
    },
    [onUpload]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "image/*": [".jpeg", ".jpg", ".png", ".pdf"]
    },
    multiple: false,
  });

  return (
    <div
      {...getRootProps()}
      className="border-2 border-dashed border-gray-400 rounded-lg p-6 text-center cursor-pointer hover:border-blue-500 transition"
    >
      <input {...getInputProps()} />
      <div className="flex flex-col items-center justify-center gap-2 text-gray-600">
        <img src={CloudUpload} alt="Upload Icon" className="w-60 h-60 mb-2" />
        {isDragActive ? (
          <p>Drop the file here...</p>
        ) : (
          <p>Upload or drag & drop your prescription</p>
        )}
        <small className="text-xs text-gray-500">Accepted formats: .jpg, .jpeg, .png, .pdf</small>
      </div>
    </div>
  );
};

export default PrescriptionUpload;
